import React, { useState, useContext, useEffect } from 'react'
import { DashboardFilled, SaveOutlined } from '@ant-design/icons'
import { Modal } from 'antd'
import { CounterContext } from 'redux/Golbalvalues'
import { useHistory } from 'react-router'
import ModalSaveRescd from 'common/Reschedule/modalSaveRescd'
const modalSaveChange = (props) => {
  const {
    form,
    SwitchAll,
    setFocus_page,
    visibleSaveChange,
    setVisibleSaveChange,
    state,
    setClick_path,
    path,
    not_step,
  } = props
  const { setDirty, disableSave } = useContext(CounterContext)
  const [visibleModalSaveRescd, setVisibleModalSaveRescd] = useState(false)
  const history = useHistory()
  let url_page = window.location.pathname
  let current_path = url_page.split('/')
  const handleOkSaveChange = () => {
    if (current_path[1] === 'reschedule') {
      setVisibleModalSaveRescd(true)
      setVisibleSaveChange(false)
    } else {
      form.submit()
    }
    setVisibleSaveChange(false)
  }
  const onCancelSaveChange = (e, type) => {
    if (e.currentTarget.id === 'discardButton') {
      type === 'information' && !not_step ? SwitchAll() : history.push(`${path}`)
      path ? history.push(`${path}`) : _
      setClick_path()
      setDirty(false)
      setVisibleSaveChange(false)
    } else {
      setClick_path()
      setVisibleSaveChange(false)
      type === 'information' ? setFocus_page('information') : _
    }
  }
  return (
    <div>
      <Modal
        maskClosable={false}
        className="ModalStatusOption"
        visible={visibleSaveChange}
        okText={'Save'}
        cancelText={'Discard'}
        onOk={handleOkSaveChange}
        onCancel={(e) => onCancelSaveChange(e, state)}
        destroyOnClose
        cancelButtonProps={{ id: 'discardButton' }}
        okButtonProps={{
          disabled: current_path[1] == 'reschedule' ? disableSave : false,
        }}
      >
        <SaveOutlined className="Icon-style" />
        <h2>Save Changes?</h2>
        <h4>Do you want to save your changes before exit?</h4>
      </Modal>
      <ModalSaveRescd
        visibleModalSaveRescd={visibleModalSaveRescd}
        setVisibleModalSaveRescd={setVisibleModalSaveRescd}
      />
    </div>
  )
}

export default modalSaveChange
